import React from 'react';
import CandidateArchive from './CandidateArchive';

/**
 * ClientCandidateArchive — Client archive (thin wrapper)
 */
const ClientCandidateArchive = () => <CandidateArchive mode="client" />;

export default ClientCandidateArchive;
